<template>
    <div
        class="item"
        @click="onGeneratorClick"
    >
        {{ generator.generatorName }}
    </div>
</template>

<script setup lang="ts">
import { FlaggedGeneratorDto } from '@/api/generated/HCA'
import { useRouter } from 'vue-router'

const props = defineProps<{
    generator: FlaggedGeneratorDto
}>()

const router = useRouter()

const onGeneratorClick = () => {
    if (!props.generator.generatorSid) {
        return
    }

    const route = router.resolve({
        name: 'Generators_ConditionStatus',
        params: {
            generatorId: props.generator.generatorSid,
        },
    })
    
    window.open(route.href, '_blank')
}
</script>

<style scoped lang="scss">
.item {
    padding: $spacing-xs $spacing-s;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: $pbl-background;

    font-weight: 500;
    transition: border-color 0.15s ease;

    user-select: none;
    cursor: pointer;
    color: $pbl-primary;

    &:hover:not(&:active) {
        border-color: $pbl-primary;
    }
}
</style>
